import { Instance } from 'mobx-state-tree';
import { TeamMemberDtoModelBase } from './TeamMemberDtoModel.base';
import getInitials from '../utils/getInitials';
import { RoleNames } from './RoleNamesEnum';

export type FunctionalRole = RoleNames.READ_ONLY | RoleNames.DISPATCHER | RoleNames.ADMIN;

/* The TypeScript type of an instance of TeamMemberDtoModel */
export interface TeamMemberDtoModelType extends Instance<typeof TeamMemberDtoModel.Type> {}

/* A graphql query fragment builders for TeamMemberDtoModel */
export { selectFromTeamMemberDto, teamMemberDtoModelPrimitives, TeamMemberDtoModelSelector } from './TeamMemberDtoModel.base';

/**
 * TeamMemberDtoModel
 */
export const TeamMemberDtoModel = TeamMemberDtoModelBase
  .views(self => ({
    get functionalRole(): FunctionalRole {
      if (self.roles.some((r) => r.name === RoleNames.ADMIN)) {
        return RoleNames.ADMIN;
      }
      return self.roles.some((r) => r.name === RoleNames.DISPATCHER) ? RoleNames.DISPATCHER : RoleNames.READ_ONLY;
    },
    get isDriver() {
      return self.driverProfileInParentOrg != null;
    },
    get initials() {
      return getInitials(self.fullname as string);
    },
  }))
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
